import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createOrder, ordersQueryKeys } from '@api/orders';

export function useCreateOrder() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createOrder,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ordersQueryKeys.lists() });
    },
  });
}
